<nz-card>
  <div
    class="ng-Header col-xs-12 d-flex justify-content-between align-items-center flex-wrap"
  >
    <span class="font-weight-bold">
      <i nz-icon nzType="unordered-list" nzTheme="outline"></i>
      Assessor's Dashboard
    </span>

    <div class="d-flex align-items-center bg-light px-3 py-2 rounded shadow-sm">
      <span class="mr-2 text-secondary font-italic">
        Looking for Assessor Enlishment form?
      </span>
      <button
        nz-button
        nzType="primary"
        nzSize="small"
        class="rounded-pill"
        (click)="applyNew()"
      >
        Click Here to Apply
      </button>
    </div>
  </div>

  <div class="row">
    <div class="col-6">
      <div
        class="single-stats-header d-md-flex align-items-cente my-2"
        style="background-color: #4573a4"
      >
        <div class="icon">
          <i nz-icon nzType="usergroup-add" nzTheme="outline"> </i>
        </div>
        <div>
          <h3>
            <b>Regular Assessment</b>
          </h3>
        </div>
      </div>
    </div>

    <div class="col-6">
      <div
        class="single-stats-header d-md-flex align-items-cente my-2"
        style="background-color: #a44569"
      >
        <div class="icon">
          <i nz-icon nzType="usergroup-add" nzTheme="outline"> </i>
        </div>
        <div>
          <h3>
            <b>Regular Reassessment </b>
          </h3>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-3">
      <!--     Certificate Issued-->
      <div
        class="single-stats-box d-md-flex align-items-cente"
        style="background-color: #e4f4ea"
      >
        <div class="icon">
          <i nz-icon nzType="file-protect" nzTheme="outline"> </i>
        </div>
        <div>
          <h3>
            {{ dashboardDetails?.regCertificateIssued || 0 }}
          </h3>
          <span class="d-block"> Certificate Issued </span>
        </div>
      </div>
      <!--      Certificate Issuance Pending-->
      <div
        class="single-stats-box d-md-flex align-items-cente"
        style="background-color: #e9e7e7"
      >
        <div class="icon">
          <i nz-icon nzType="hourglass" nzTheme="outline"> </i>
        </div>
        <div>
          <h3>
            {{ dashboardDetails?.regCertificateIssuancePending || 0 }}
          </h3>
          <span class="d-block"> Certificate Issuance Pending </span>
        </div>
      </div>
    </div>

    <div class="col-3">
      <!--      Results Uploaded-->
      <div
        class="single-stats-box d-md-flex align-items-cente"
        style="background-color: #f6ebe7"
      >
        <div class="icon">
          <i nz-icon nzType="file-done" nzTheme="outline"> </i>
        </div>
        <div>
          <h3>
            {{ dashboardDetails?.regResultsUploaded || 0 }}
          </h3>
          <span class="d-block"> Results Uploaded </span>
        </div>
      </div>

      <!--      Results Upload Pending-->
      <div
        class="single-stats-box d-md-flex align-items-cente"
        style="background-color: #cedde0ff"
      >
        <div class="icon">
          <i nz-icon nzType="hourglass" nzTheme="outline"> </i>
        </div>
        <div>
          <h3>
            {{ dashboardDetails?.regResultsUploadPending || 0 }}
          </h3>
          <span class="d-block"> Results Upload Pending </span>
        </div>
      </div>
    </div>

    <div class="col-3">
      <!--     Certificate Issued-->
      <div
        class="single-stats-box d-md-flex align-items-cente"
        style="background-color: #e4f4ea"
      >
        <div class="icon">
          <i nz-icon nzType="file-protect" nzTheme="outline"> </i>
        </div>
        <div>
          <h3>
            {{ dashboardDetails?.regReCertificateIssued || 0 }}
          </h3>
          <span class="d-block"> Certificate Issued </span>
        </div>
      </div>
      <!--      Certificate Issuance Pending-->
      <div
        class="single-stats-box d-md-flex align-items-cente"
        style="background-color: #e9e7e7"
      >
        <div class="icon">
          <i nz-icon nzType="hourglass" nzTheme="outline"> </i>
        </div>
        <div>
          <h3>
            {{ dashboardDetails?.regReCertificateIssuancePending || 0 }}
          </h3>
          <span class="d-block"> Certificate Issuance Pending </span>
        </div>
      </div>
    </div>

    <div class="col-3">
      <!--      Results Uploaded-->
      <div
        class="single-stats-box d-md-flex align-items-cente"
        style="background-color: #f6ebe7"
      >
        <div class="icon">
          <i nz-icon nzType="file-done" nzTheme="outline"> </i>
        </div>
        <div>
          <h3>
            {{ dashboardDetails?.regReResultsUploaded || 0 }}
          </h3>
          <span class="d-block"> Results Uploaded </span>
        </div>
      </div>

      <!--      Results Upload Pending-->
      <div
        class="single-stats-box d-md-flex align-items-cente"
        style="background-color: #cedde0ff"
      >
        <div class="icon">
          <i nz-icon nzType="hourglass" nzTheme="outline"> </i>
        </div>
        <div>
          <h3>
            {{ dashboardDetails?.regReResultsUploadPending || 0 }}
          </h3>
          <span class="d-block"> Results Upload Pending </span>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-6">
      <div
        class="single-stats-header d-md-flex align-items-cente my-2"
        style="background-color: #45a4a1"
      >
        <div class="icon">
          <i nz-icon nzType="user-add" nzTheme="outline"> </i>
        </div>
        <div>
          <h3>
            <b>RPL Assessment</b>
          </h3>
        </div>
      </div>
    </div>

    <div class="col-6">
      <div
        class="single-stats-header d-md-flex align-items-cente my-2"
        style="background-color: #a44550"
      >
        <div class="icon">
          <i nz-icon nzType="user-add" nzTheme="outline"> </i>
        </div>
        <div>
          <h3>
            <b>RPL Reassessment </b>
          </h3>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-3">
      <!--     Certificate Issued-->
      <div
        class="single-stats-box d-md-flex align-items-cente"
        style="background-color: #e4f4ea"
      >
        <div class="icon">
          <i nz-icon nzType="file-protect" nzTheme="outline"> </i>
        </div>
        <div>
          <h3>
            {{ dashboardDetails?.rplCertificateIssued || 0 }}
          </h3>
          <span class="d-block"> Certificate Issued </span>
        </div>
      </div>
      <!--      Certificate Issuance Pending-->
      <div
        class="single-stats-box d-md-flex align-items-cente"
        style="background-color: #e9e7e7"
      >
        <div class="icon">
          <i nz-icon nzType="hourglass" nzTheme="outline"> </i>
        </div>
        <div>
          <h3>
            {{ dashboardDetails?.rplCertificateIssuancePending || 0 }}
          </h3>
          <span class="d-block"> Certificate Issuance Pending </span>
        </div>
      </div>
    </div>

    <div class="col-3">
      <!--      Results Uploaded-->
      <div
        class="single-stats-box d-md-flex align-items-cente"
        style="background-color: #f6ebe7"
      >
        <div class="icon">
          <i nz-icon nzType="file-done" nzTheme="outline"> </i>
        </div>
        <div>
          <h3>
            {{ dashboardDetails?.rplResultsUploaded || 0 }}
          </h3>
          <span class="d-block"> Results Uploaded </span>
        </div>
      </div>

      <!--      Results Upload Pending-->
      <div
        class="single-stats-box d-md-flex align-items-cente"
        style="background-color: #cedde0ff"
      >
        <div class="icon">
          <i nz-icon nzType="hourglass" nzTheme="outline"> </i>
        </div>
        <div>
          <h3>
            {{ dashboardDetails?.rplResultsUploadPending || 0 }}
          </h3>
          <span class="d-block"> Results Upload Pending </span>
        </div>
      </div>
    </div>

    <div class="col-3">
      <!--     Certificate Issued-->
      <div
        class="single-stats-box d-md-flex align-items-cente"
        style="background-color: #e4f4ea"
      >
        <div class="icon">
          <i nz-icon nzType="file-protect" nzTheme="outline"> </i>
        </div>
        <div>
          <h3>
            {{ dashboardDetails?.rplReCertificateIssued || 0 }}
          </h3>
          <span class="d-block"> Certificate Issued </span>
        </div>
      </div>
      <!--      Certificate Issuance Pending-->
      <div
        class="single-stats-box d-md-flex align-items-cente"
        style="background-color: #e9e7e7"
      >
        <div class="icon">
          <i nz-icon nzType="hourglass" nzTheme="outline"> </i>
        </div>
        <div>
          <h3>
            {{ dashboardDetails?.rplReCertificateIssuancePending || 0 }}
          </h3>
          <span class="d-block"> Certificate Issuance Pending </span>
        </div>
      </div>
    </div>

    <div class="col-3">
      <!--      Results Uploaded-->
      <div
        class="single-stats-box d-md-flex align-items-cente"
        style="background-color: #f6ebe7"
      >
        <div class="icon">
          <i nz-icon nzType="file-done" nzTheme="outline"> </i>
        </div>
        <div>
          <h3>
            {{ dashboardDetails?.rplReResultsUploaded || 0 }}
          </h3>
          <span class="d-block"> Results Uploaded </span>
        </div>
      </div>

      <!--      Results Upload Pending-->
      <div
        class="single-stats-box d-md-flex align-items-cente"
        style="background-color: #cedde0ff"
      >
        <div class="icon">
          <i nz-icon nzType="hourglass" nzTheme="outline"> </i>
        </div>
        <div>
          <h3>
            {{ dashboardDetails?.rplReResultsUploadPending || 0 }}
          </h3>
          <span class="d-block"> Results Upload Pending </span>
        </div>
      </div>
    </div>
  </div>

  <div class="card" *ngIf="blobkUnblockData?.length > 0">
    <div nz-col [nzSpan]="24">
      <div class="ng-Header col-xs-12">
        <i nz-icon nzType="unordered-list" nzTheme="outline"></i>
        Blocking Details
      </div>

      <nz-table
        #basicTable
        [nzData]="blobkUnblockData"
        nzTableLayout="fixed"
        nzShowSizeChanger
        nzBordered
        nzSize="middle"
        nzAlign="middle"
        [nzShowTotal]="totalRowRangeTemplate"
        [(nzPageSize)]="size"
        [(nzPageIndex)]="page"
        [nzShowPagination]="true"
        [nzFrontPagination]="true"
        [nzScroll]="{ x: '1150px' }"
      >
        <ng-template
          #totalRowRangeTemplate
          let-range="range"
          let-total
          style="text-align: left"
        >
          <div style="text-align: left">
            Showing {{ range[0] }}-{{ range[1] }} of {{ total }} items
          </div>
        </ng-template>
        <thead>
          <tr>
            <th nzWidth="3%">SL</th>
            <th>Application ID</th>
            <th>Occupation</th>
            <th>Level</th>
            <th>Unblock Countdown</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let data of basicTable.data; let i = index">
            <td>
              {{ (page - 1) * size + 1 + i }}
            </td>
            <td>{{ data?.applicationId }}</td>
            <td>
              {{ data.occupation }}
            </td>
            <td>{{ data.levelId }}</td>
            <td>{{ data.displayTime }}</td>
          </tr>
        </tbody>
      </nz-table>
    </div>
  </div>
</nz-card>
